// Lightweight wrapper to expose pell as a global and provide an init function
import * as pell from './pell.js';

export function initPellJs() {
  if (typeof window !== 'undefined' && !window.pell) {
    window.pell = pell;
    if (typeof document !== 'undefined') {
      // Prefer modern Event constructor when available, otherwise fall back to createEvent
      if (typeof window !== 'undefined' && typeof window.Event === 'function') {
        document.dispatchEvent(new window.Event('pell:loaded'));
      } else if (document.createEvent) {
        var evt = document.createEvent('Event');
        evt.initEvent('pell:loaded', true, true);
        document.dispatchEvent(evt);
      }
    }
  }
  return window.pell;
}

export default initPellJs;
